import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { getHeaders } from '../utils/headers.functions';

const API = environment.API_URL;

export interface UserLandingPage {
  id:              number;
  name:            string;
  slug?:           string;
  type:            'course' | 'ebook' | 'service' | 'custom';
  templateId:      string;
  status:          'draft' | 'published' | 'archived';
  productId?:      number;
  funnelId?:       number;
  metaTitle?:      string;
  metaDescription?:string;
  utmSource?:      string;
  views:           number;
  conversions:     number;
  data?:           any;
  updatedAt?:      string;
  product?:        { id: number; name: string; Slug: string };
  funnel?:         { id: number; funnelName: string };
}

@Injectable({ providedIn: 'root' })
export class LandingPagesService {

  constructor(private http: HttpClient) {}

  getAll(search = '', status = '', page = 1, limit = 20): Observable<any> {
    let params = new HttpParams()
      .set('page', page)
      .set('limit', limit);
    if (search) { params = params.set('search', search); }
    if (status) { params = params.set('status', status); }
    return this.http.get<any>(`${API}/user-landing-pages`, { headers: getHeaders(), params });
  }

  getById(id: number): Observable<UserLandingPage> {
    return this.http.get<UserLandingPage>(`${API}/user-landing-pages/${id}`, { headers: getHeaders() });
  }

  create(payload: Partial<UserLandingPage>): Observable<UserLandingPage> {
    return this.http.post<UserLandingPage>(`${API}/user-landing-pages`, payload, { headers: getHeaders() });
  }

  update(id: number, payload: Partial<UserLandingPage>): Observable<UserLandingPage> {
    return this.http.put<UserLandingPage>(`${API}/user-landing-pages/${id}`, payload, { headers: getHeaders() });
  }

  saveBuilder(id: number, data: any): Observable<any> {
    return this.http.put(`${API}/user-landing-pages/${id}/builder`, { data }, { headers: getHeaders() });
  }

  publish(id: number): Observable<any> {
    return this.http.post(`${API}/user-landing-pages/${id}/publish`, {}, { headers: getHeaders() });
  }

  unpublish(id: number): Observable<any> {
    return this.http.post(`${API}/user-landing-pages/${id}/unpublish`, {}, { headers: getHeaders() });
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${API}/user-landing-pages/${id}`, { headers: getHeaders() });
  }

  getFunnelWidgets(id: number): Observable<any[]> {
    return this.http.get<any[]>(`${API}/user-landing-pages/${id}/funnel-widgets`, { headers: getHeaders() });
  }
}
